export const AUTO_ADVANCE_ON_COMPLETION = 'auto_advance_on_completion';
export const IS_HIDDEN_FROM_PORTAL = 'is_hidden_from_portal';
export const GET_SSN_CONFIRMATION = 'get_ssn_confirmation';
export const EMAIL_I9_FORM = 'email_i9_form';
export const EMAIL_I9_SECTION_ONE = 'email_i9_section_one';
export const SHOULD_AUTO_ADVANCE_WHEN_LABELS_COMPLETE =
  'should_auto_advance_when_labels_complete';
